export default function () {
  const widgetName = "multiScheduleFeature";
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    // options
    allEventsLink: true,
    allEventsLinkText: "View All Events",
    hasImages: false,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: { visible: false, text: "BUY NOW" },
    moreButton: { visible: false, text: "MORE" },
    maxItemsVisible: 5,
    isResponsive: false,
    hasDescription: false,
    textContainer: true,
    link: "all", //options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: "date",
      2: "title",
      3: "image",
      4: "description",
      5: "buttons",
    },
    multiFeatureLoaded: function (data) {
      const widgetData = data;

      if (widgetData.length > 0) {
        createCustomEventDates(widgetData);
      }

      $("#multiScheduleFeature .multiFeatureContent").prepend(
        "<span>Coming Up</span>"
      );

      $("#multiScheduleFeature .all-events-btn").addClass("button");
    },
  });

  function createCustomEventDates(widgetData) {
    $("#multiScheduleFeature .featureItem").each(function (i) {
      const {  Date: widgetDate } = widgetData[i];

      let fixedDate = widgetDate.split("-");
      let dayStart;
      let monthStart;
      let dayEnd;
      let monthEnd;
      let dateLayout;

      switch (fixedDate.length) {
        case 1:
          dayStart = formatDate(fixedDate, 0, 0, 1);
          monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
          dateLayout = buildEventDateLayout(monthStart, dayStart);
          break;

        case 2:
          monthStart = formatDate(fixedDate, 0, 0, 0).substring(0, 3);
          dayStart = formatDate(fixedDate, 0, 0, 1);
          monthEnd = formatDate(fixedDate, 1, 0, 0).substring(0, 3);
          dayEnd = formatDate(fixedDate, 1, 0, 1);
          dateLayout = buildEventDateLayout(
            monthStart,
            dayStart,
            monthEnd,
            dayEnd
          );
          break;

        default:
          break;
      }

      $(this).find(".featureItemDate").replaceWith(dateLayout);
    });
  }
}

function formatDate(date, slot1, slot2, slot3) {
  let splittedDate = date[slot1]
    .trim()
    .split(",")
    [slot2].trim()
    .split(" ")
    [slot3].trim();
  return splittedDate;
}

function buildEventDateLayout(
  eventStartMonth,
  eventStartDay,
  eventEndMonth = null,
  eventEndDay = null
) {
  let dateLayout;
  if (eventEndMonth === null || eventEndDay === null) {
    dateLayout = `
            <div class="event-date ">
                <span class="month">${eventStartMonth}</span>
                <span class="day">${eventStartDay}</span>
            </div>`;
  } else if (eventStartMonth == eventEndMonth) {
    dateLayout = `
            <div class="event-date double-date">
                <span class="month">${eventStartMonth}</span>
                <span class="day">${eventStartDay}<span class="separator">-</span>${eventEndDay}</span>
            </div>`;
  } else {
    dateLayout = `
            <div class="event-date date-range">
                <div class="combo-date">
                    <span class="month">${eventStartMonth}</span>
                    <span class="day">${eventStartDay}</span>
                    </div>
                    
                <span class="separator-month">-</span>
  
                <div class="combo-date">
                    <span class="month">${eventEndMonth}</span>
                    <span class="day">${eventEndDay}</span>
                </div>
            </div>`;
  }
  return dateLayout;
}
